/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import { connect } from 'react-redux';
import List from '@material-ui/core/List';
import { Close, Filter, Delete } from 'Utils/SvgIcons';
import * as actions from 'Actions';
import DateSelector from './DateSelector';
import ScrollArea from 'Utils/react-scrollbar';
import Modal from 'Utils/Modal';
import ColorPicker from 'Utils/ColorPicker';
import Slider, { createSliderWithTooltip } from 'rc-slider';
import ShopBreadCrumbs from '../utils/ShopBreadCrumbs';
import SfCategoryTree from './SfCategoryTree';
import withCategoryFilterAutoExpansion from './withCategoryFilterAutoExpansion';

const Range = createSliderWithTooltip(Slider.Range);

// This component is only called from the mobile size, via
class CategoryFilterMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterOpen: false,
      openCategories: false,
    };
    this.handleFilterClose = this.handleFilterClose.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
  }

  handleFilterClose() {
    this.setState({ filterOpen: false });
  }

  toggleFilter() {
    this.setState({ filterOpen: !this.state.filterOpen });
  }

  checkSfCategorySelected = ({ id }) => {
    const { selectedSfCategories } = this.props;
    return selectedSfCategories.includes(String(id));
  };

  requireRentalDatesBeforePickingInventory = () => {
    return this.props.location.overbookingOnSf === 'disallowed';
  };

  render() {
    const {
      onColorSelection,
      selectedColors,
      clearColorSelection,
      onQuantitySelection,
      selectedMinQuantity,
      selectedMaxQuantity,
      storefrontShopSetting,
      showFilters,
      currentCategory,
    } = this.props;

    const allowedFilterList = storefrontShopSetting.allowedFilters.split(',');
    const quantityValues = [+selectedMinQuantity, +selectedMaxQuantity];

    if (
      !(
        allowedFilterList.includes('date') ||
        allowedFilterList.includes('quantity') ||
        allowedFilterList.includes('color') ||
        allowedFilterList.includes('category')
      )
    ) {
      return null;
    }
    return (
      <aside className='mobileFilter'>
        <a onClick={this.toggleFilter}>
          <Filter />
        </a>
        <div className='breadcrumbs'>
          <ShopBreadCrumbs
            sfCategories={this.props.sfCategories}
            currentCategory={currentCategory}
          />
        </div>

        <Modal
          className='filterModal'
          open={this.state.filterOpen}
          toggle={this.toggleFilter}
          title='Filter'
        >
          <a className='linkClose' onClick={this.handleFilterClose}>
            <Close />
          </a>
          <h3>Filter</h3>
          {this.requireRentalDatesBeforePickingInventory() && <DateSelector />}
          {showFilters === false && (
            <div className='colorAGroup' id='categoryLinks'>
              <ScrollArea speed={0.8} horizontal={false}>
                <List className='checkList'>
                  <SfCategoryTree
                    sfCategories={this.props.sfCategories}
                    open={this.props.open}
                    toggleOpen={this.props.toggleOpen}
                    checkCategorySelected={this.checkSfCategorySelected}
                    handleCategorySelected={this.props.handleSfCategorySelected}
                    currentCategory={currentCategory}
                    theme={this.props.theme}
                    showCheckbox={!currentCategory}
                  />
                </List>
              </ScrollArea>
            </div>
          )}
          {showFilters && (
            <div className='filterWrapper'>
              {allowedFilterList.includes('date') &&
                !this.requireRentalDatesBeforePickingInventory() && (
                  <DateSelector />
                )}

              {allowedFilterList.includes('quantity') && (
                <div id='tooltipContainer' className='quantityFilter'>
                  <div
                    ref={(input) => {
                      this.tooltipContainer = input;
                    }}
                  />
                  Quantity
                  <Range
                    allowCross={false}
                    value={quantityValues}
                    onChange={onQuantitySelection}
                    max={500}
                    tipProps={{
                      visible: true,
                      getTooltipContainer: () => this.tooltipContainer,
                    }}
                  />
                </div>
              )}
              {allowedFilterList.includes('color') && (
                <div className='colorFilter'>
                  Color
                  <ColorPicker
                    onColorSelection={onColorSelection}
                    selectedColorIds={selectedColors}
                    clearColorSelection={clearColorSelection}
                  />
                </div>
              )}
              {currentCategory && allowedFilterList.includes('category') && (
                <div className='colorAGroup' id='categoryLinks'>
                  <ScrollArea speed={0.8} horizontal={false}>
                    <List className='checkList'>
                      <SfCategoryTree
                        sfCategories={this.props.sfCategories}
                        open={this.props.open}
                        toggleOpen={this.props.toggleOpen}
                        checkCategorySelected={this.checkSfCategorySelected}
                        handleCategorySelected={
                          this.props.handleSfCategorySelected
                        }
                        currentCategory={currentCategory}
                        theme={this.props.theme}
                        showCheckbox={false}
                      />
                    </List>
                  </ScrollArea>
                </div>
              )}
            </div>
          )}
        </Modal>
      </aside>
    );
  }
}

const mapStateToProps = (state) => {
  const { parsedStorefrontSettings, location } = state.locations;
  const storefrontShopSetting = parsedStorefrontSettings.storefrontShopSetting;
  const { sfCategories, inventoryCategoryGroups } = state.categoryList;
  return {
    sfCategories,
    inventoryCategoryGroups,
    storefrontShopSetting,
    location,
  };
};

export default connect(
  mapStateToProps,
  actions
)(withCategoryFilterAutoExpansion(CategoryFilterMobile));
